import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { environment } from 'environments/environment';


@Component({
  selector: 'pgs-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {

  public version;

  constructor() {
    this.version = environment.appVersion; 
  }
}
